import { useState, useMemo } from "react";
import {
  useReactTable,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
} from "@tanstack/react-table";
import { Table } from "reactstrap";
import { FaArrowUp, FaArrowDown } from "react-icons/fa6";

export default function DataGrid({ rows, columns }) {
  const [sorting, setSorting] = useState([]);

  const tableColumns = useMemo(
    () =>
      columns.map((col) => ({
        id: col.id,
        accessorKey: col.key,
        header: col.header,
        size: col.width ?? 150,
        cell: (props) => props.getValue(),
        enableSorting: col.sortable !== false,
        enableResizing: true,
        sortingFn: col.sortable === false ? undefined : col.sortingFn,
      })),
    [columns]
  );

  const table = useReactTable({
    data: rows,
    columns: tableColumns,
    state: { sorting },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    columnResizeMode: "onChange",
  });

  return (
    <div className="card">
      <Table className="table-striped" style={{ width: "100%" }}>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  style={{
                    position: "relative",
                    width: header.getSize(),
                    userSelect: "none",
                    color: header.column.getIsSorted() ? "#20a8d8" : undefined,
                  }}
                >
                  <div
                    className="align-items-center justify-content-center"
                    style={{ cursor: "pointer" }}
                    onClick={header.column.getToggleSortingHandler()}
                  >
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                    {header.column.getCanSort() && (
                      <span className="ms-1">
                        {
                          {
                            asc: <FaArrowUp />,
                            desc: <FaArrowDown />,
                          }[header.column.getIsSorted()]
                        }
                      </span>
                    )}
                  </div>
                  {header.column.getCanResize() && (
                    <span
                      className={`resizer ${
                        header.column.getIsResizing() ? "isResizing" : ""
                      }`}
                      onMouseDown={header.getResizeHandler()}
                      onTouchStart={header.getResizeHandler()}
                    >
                      <div className="divider-line" />
                      <div className="divider-line" />
                    </span>
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id} className="align-content-center">
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
